import { Modal } from "antd";
import CustomerLink from "../../shared/CustomerLink";
import { IoChevronBackCircleSharp } from "react-icons/io5";

const usd = (n) =>
  `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const CryptoDetail = ({ record, open, setOpen }) => {
  console.log({
    record
  })
  return (
    <Modal title="" open={open} footer={null} onCancel={() => setOpen(false)}>
      <h2 className="font-bold text-[20px] text-center line-[32px]">Transaction details</h2>
      <div className="flex justify-center items-center">
      <IoChevronBackCircleSharp color="green" size={25} />
      </div>
      <p className="text-[18px] text-center font-[500] uppercase">{record?.metadata?.type === "receive" ? "Received" : record?.metadata?.type === "send" ? "Sent" : record?.metadata?.transactionType === "sell" ? "Sold" : "Purchased"} {`${record.metadata?.coinQty} ${record.coin || record.metadata?.coinType}`}</p>
      <p className="text-[12px] text-center text-[#787389]">
        {new Date(record.createdAt).toLocaleDateString()}{" "}{new Date(record.createdAt).toLocaleTimeString()}
      </p>

      <div className="flex justify-between mt-5">
        <p>Customer</p>        
        <CustomerLink record={record} />
      </div>

      <div className="flex justify-between mt-5">
        <p>Customer Email</p>        
        <p>{record.user?.email}</p>
      </div>

      <div className="flex justify-between mt-2 mb-2">
        <p>Status</p>
        <p className="capitalize">{record.status}</p>
      </div>

      <hr />

      <div className="flex justify-between mt-5">
        <p>Token</p>
        {/* <p>{record.coin.includes(":") ? record.coin.split(":")[1] : record.coin}</p> */}
        <p>{record.coin}</p>
      </div>

      <div className="flex justify-between mt-2">
        <p>Token Amount</p>
        <p>{Number(record.metadata?.coinQty)}</p>
      </div>

      {record.metadata?.nairaReceived &&
      <div className="flex justify-between mt-2">
        <p>Amount Received (NGN)</p>
        <p>{Number(record.metadata?.nairaReceived).toLocaleString()}</p>
      </div>
      }

      {record.metadata?.ratePerUsd &&
      <div className="flex justify-between mt-2">
        <p>Rate</p>
        <p>{Number(record.metadata?.ratePerUsd)}</p>
      </div>
      }
      
      {record.usdAtTrade != null &&
      <div className="flex justify-between mt-2">
        <p>Value when traded</p>
        <p>{usd(record.usdAtTrade)}</p>
      </div>
      }

      {record.usdNow != null &&
      <div className="flex justify-between mt-2">
        <p>Current value</p>
        <p>{usd(record.usdNow)}</p>
      </div>
      }

      <div className="flex justify-between mt-2">
        <p>Coin Rate</p>
        <p>$ {Number((record?.metadata?.usdRate || record?.metadata?.priceUsd || 0)).toLocaleString()}</p>
      </div>

      {record?.metadata?.rate &&
      <div className="flex justify-between mt-2">
        <p>Rate</p>
        <p>NGN {Number((record?.metadata?.rate || 0)).toLocaleString()}</p>
      </div>
      }

      <div className="flex justify-between mt-2">
        <p>Order ID</p>
        <p>{record?._id}</p>
      </div>

      {record?.metadata?.createdTime &&
      <div className="flex justify-between mt-2">
        <p>Created Time</p>
        <p>{new Date(record?.metadata.createdTime).toLocaleString()}</p>
      </div>
      }

      {record?.metadata?.confirmedTime &&
      <div className="flex justify-between mt-2">
        <p>Confirmation Time</p>
        <p>{new Date(record?.metadata.confirmedTime).toLocaleString()}</p>
      </div>
      }

      {record?.providerRef && 
      <div className="flex justify-between mt-2">
        <p>Bitgo Transaction ID</p>
        <p>{record?.providerRef}</p>
      </div>
      }
    </Modal>
  );
};

export default CryptoDetail;
